import { render, staticRenderFns } from "./indexhud.vue?vue&type=template&id=3fb4d80e&"
import script from "./indexhud.vue?vue&type=script&lang=js&"
export * from "./indexhud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports